import {
  Box,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import styled from '@emotion/styled';

import ClienteInadimplente from '../../assets/cliente-inadimplente-color.svg';
import ClienteEmDia from './../../assets/cliente-em-dia-color.svg';
import { formatToLocaleCurrency } from '../../util/formats';

const colunasCobranca = [
  { id: 'cliente', label: 'Cliente', minWidth: 100, align: 'left', },
  { id: 'idDaCobranca', label: 'ID da cob.', minWidth: 100, align: 'left', },
  { id: 'valor', label: 'Valor', minWidth: 100, align: 'left', },
];

const colunasCliente = [
  { id: 'cliente', label: 'Cliente', minWidth: 160, align: 'left', },
  { id: 'id_cliente', label: 'ID do Cliente', minWidth: 130, align: 'left', },
  { id: 'cpf', label: 'CPF', minWidth: 70, align: 'left', },
];

const cores = {
  0: {
    texto: '#971D1D',
    fundo: '#FFEFEF',
  },
  1: {
    texto: '#C5A605',
    fundo: '#FCF6DC',
  },
  2: {
    texto: '#1FA7AF',
    fundo: '#EEF6F6',
  },

};

const TableCellConteudo = styled(TableCell)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.005em;
  padding: 2px;
  color: #6E6E85;
`;

export function Card({ cliente = false, cor, dados, resumo = {}, titulo }) {

  return (
    <Paper
      elevation={0}
      sx={{
        width: `${cliente ? '555px' : '360px'}`,
        backgroundColor: 'transparent',
      }}
    >
      <TableContainer
        sx={{
          px: '8px',
          backgroundColor: '#FFFFFF',
          borderRadius: '30px',
          boxShadow: '0px 4px 4px rgba(172, 217, 197, 0.25)',
        }}
      >
        <Table
          stickyHeader
          aria-label='sticky table'
        >
          <TableHead>
            <TableRow sx={{ maxHeight: '58px' }} >
              <TableCell
                align={`${cliente ? 'left' : 'right'}`}
                colSpan={2}
                sx={{
                  fontFamily: 'Montserrat',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  fontSize: '18px',
                  lineHeight: '23px',
                  color: '#3F3F55',
                  verticalAlign: 'center',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: `${cliente ? 'flex-start' : 'flex-end'}`, }} >
                  {cliente && (
                    cor === 0 ?
                      <img src={ClienteInadimplente} alt="ícone cliente inadimplente" style={{ marginRight: '8px' }} /> :
                      <img src={ClienteEmDia} alt="ícone cliente em dia" style={{ marginRight: '8px' }} />
                  )}
                  {titulo}
                </Box>
              </TableCell>

              <TableCell colSpan={1} sx={{ position: 'relative', }} >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '19px',
                    right: '24px',
                    width: '52px',
                    height: '21px',
                    padding: '0px 15px',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    fontSize: '16px',
                    lineHeight: '21px',
                    textAlign: 'center',
                    color: `${cores[cor].texto}`,
                    backgroundColor: `${cores[cor].fundo}`,
                    borderRadius: '8px',
                  }}
                >
                  {cliente ? (!dados ? 0 : dados.length) : resumo.cobrancas}
                </Box>
              </TableCell>
            </TableRow>

            <TableRow>
              {(cliente ? colunasCliente : colunasCobranca).map((coluna) => (
                <TableCell
                  key={coluna.id}
                  align={coluna.align}
                  style={{ top: 57, minWidth: coluna.minWidth }}
                  sx={{
                    fontFamily: 'Nunito',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    fontSize: '16px',
                    lineHeight: '35px',
                    letterSpacing: '0.005rem',
                    color: '#3F3F55',
                  }}
                >
                  {coluna.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {dados?.slice(0, 4)
              .map((item, index) => (
                <TableRow hover role='checkbox' tabIndex={-1} key={index} sx={{ height: '58px', /* p: '16px', */ /* gap: '8px', */ }} >
                  <TableCellConteudo /* key={item.id} */ align='left' /* sx={{ p: '12px', }} */ /* style={{ padding: '0 10px' }} */ >
                    {item.nome}
                  </TableCellConteudo>

                  <TableCellConteudo /* key={item.id} */ align='center' >
                    {cliente ? item.id : item.id_cobranca}
                  </TableCellConteudo>

                  <TableCellConteudo /* key={item.id} */ align='left' >
                    {cliente ?
                      ((cpf) => {
                        cpf = cpf.replace(/\D/g, '');
                        cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');

                        return cpf;
                      })(item.cpf) :
                      formatToLocaleCurrency(item.valor)
                    }
                  </TableCellConteudo>
                </TableRow>
              ))}
          </TableBody>

          <TableFooter>
            <TableRow>
              <TableCell align='center' colSpan={3} >
                <Link
                  variant='body2'
                  underline='always'
                  sx={{
                    fontFamily: 'Nunito',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '18px',
                    letterSpacing: '0.005rem',
                    color: '#DA0175',
                    textDecorationColor: '#DA0175',
                    cursor: 'pointer',
                  }}
                >
                  Ver todos
                </Link>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Paper >
  );
};
